import Router from "@/common/router/Router";

export default class SensorRouter extends Router {
  static BASE_PATH = "/sensor";
  static SHOW_ROUTE_NAME = "sensor-show";
  static CREATE_ROUTE_NAME = "sensor-create";
  static UPDATE_ROUTE_NAME = "sensor-update";
  static LIST_ROUTE_NAME = "sensor-list";

  constructor() {
    super(
      SensorRouter.BASE_PATH,
      SensorRouter.SHOW_ROUTE_NAME,
      SensorRouter.CREATE_ROUTE_NAME,
      SensorRouter.UPDATE_ROUTE_NAME,
      SensorRouter.LIST_ROUTE_NAME
    );
  }
}

export const sensorRouter = new SensorRouter();
